import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBusinessEntities(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('directory/business-entities', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBusinessEntity(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`directory/business-entities/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
